"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigninWithWhatsappButton = void 0;
const react_1 = __importDefault(require("react"));
require("./SignInWithWhatsapp.scss");
const SignInWithWhatsapp_scss_json_1 = __importDefault(require("./SignInWithWhatsapp.scss.json"));
const Button_1 = require("lincd-mui-base/lib/components/Button");
const ClassNames_1 = require("lincd/lib/utils/ClassNames");
const package_1 = require("../package");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const OTPInput_1 = require("lincd-input/lib/components/OTPInput");
const react_international_phone_1 = require("react-international-phone");
require("react-international-phone/style.css");
const google_libphonenumber_1 = require("google-libphonenumber");
const useAuth_1 = require("lincd-auth/lib/hooks/useAuth");
const LinkedFileStorage_1 = require("lincd/lib/utils/LinkedFileStorage");
const react_2 = require("@tolgee/react");
const SigninWithWhatsappButton = ({ label = 'Sign in with Whatsapp', // default text button
className, // additional CSS classNames to apply to the button
onCallback, // callback function invoked when the Google authentication is successful.
restProps, onSuccess, }) => {
    const phoneUtil = google_libphonenumber_1.PhoneNumberUtil.getInstance();
    const isPhoneValid = (phoneNumber) => {
        try {
            return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phoneNumber));
        }
        catch (error) {
            return false;
        }
    };
    const [otpField, setOTPField] = react_1.default.useState(false);
    const [OTPNumber, setOTPNumber] = react_1.default.useState('');
    const [user, setUser] = react_1.default.useState({});
    const [OTPRetrieve, setOTPRetrieve] = react_1.default.useState('');
    const [phoneNumber, setPhoneNumber] = react_1.default.useState('');
    const [phoneNumberField, setPhoneNumberField] = react_1.default.useState(false);
    const [isLoading, setLoading] = react_1.default.useState(false);
    const [messageData, setMessageData] = react_1.default.useState({});
    const isValid = isPhoneValid(phoneNumber);
    const auth = (0, useAuth_1.useAuth)();
    const { t } = (0, react_2.useTranslate)();
    let prefix = 'signIn';
    const OTP_Received = (OPT_input) => {
        // if (OTP === OTPRetrieve.toString()) {
        validateOTP(phoneNumber, OPT_input);
        // } else {
        //   validateOTP(false, messageData);
        // }
        return;
    };
    const validateOTP = (phoneNumber, OPT_input) => {
        // backend already validate the OTP and return true or false here. if telephone means OTP is valid true / false
        if (phoneNumber && OPT_input) {
            Server_1.Server.call(package_1.packageName, 'validateOTPWhatsapp', phoneNumber, OPT_input).then((response) => {
                if (response && response.auth) {
                    auth.updateAuth(response.auth, response.accessToken, response.refreshToken);
                    onSuccess(true);
                }
                else if (response === null || response === void 0 ? void 0 : response.error) {
                    //TODO: user error message
                    alert(response.error);
                }
                else {
                    onSuccess(false);
                }
            });
            // .catch((error) => {
            //   console.error('Error signing in with WhatsApp:', error);
            //   // Handle the error appropriately (e.g., show an error message to the user)
            //   // You might want to call `onSuccess(false)` or display an error message here
            // });
        }
    };
    const handleLoading = () => {
        setLoading(false);
    };
    const sendWhatsappMessage = (phoneNumber) => {
        setLoading(true);
        if (!isValid) {
            setLoading(false);
            setPhoneNumber('');
            return;
        }
        Server_1.Server.call(package_1.packageName, 'generateOTPWhatsapp', phoneNumber).then((response) => {
            const { data, otp, user } = response;
            setMessageData(data);
            setOTPField(true);
            setLoading(false);
            setOTPRetrieve(otp);
            setUser(user);
        });
    };
    // const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //   const inputValue = event.target.value.replace(/[^0-9]/g, '');
    //   setPhoneNumber(inputValue);
    // };
    return (react_1.default.createElement(react_1.default.Fragment, null, !otpField && !phoneNumberField ? (react_1.default.createElement(Button_1.Button, Object.assign({ className: (0, ClassNames_1.cl)(SignInWithWhatsapp_scss_json_1.default.root, className), onClick: () => setPhoneNumberField(true), variant: "outlined", fullWidth: true, startIcon: react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)('/images/wa_icon.png'), alt: "whatsapp-icon", className: SignInWithWhatsapp_scss_json_1.default.WhatsappIcon }) }, restProps), t(prefix + '.whatsapp', label))) : isLoading ? (react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)('/images/loading.gif'), className: SignInWithWhatsapp_scss_json_1.default.loading, alt: "loading" })) : phoneNumberField && !otpField ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_international_phone_1.PhoneInput, { defaultCountry: "us", value: phoneNumber, onChange: (phoneNumber) => setPhoneNumber(phoneNumber) }),
        !isValid && phoneNumber === '' ? (react_1.default.createElement("div", { style: { color: 'red' } }, "Phone is not valid")) : null,
        react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)('/images/signButton.png'), className: SignInWithWhatsapp_scss_json_1.default.signButton, onClick: () => sendWhatsappMessage(phoneNumber) }))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h3", null, "Enter your OTP code"),
        react_1.default.createElement(OTPInput_1.OTPInput, { onClick: OTP_Received, isLoading: handleLoading })))));
};
exports.SigninWithWhatsappButton = SigninWithWhatsappButton;
//# sourceMappingURL=SignInWithWhatsapp.js.map